import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import BaseSection from '../BaseSection';

const InfoSection = memo(
  ({ priceMin, currency, deadline, hasBillOfSale, apartments }) => {
    const { t } = useTranslation();
    const min =
      apartments?.length > 0 && Math.min(...apartments?.map(item => item.area));
    const max =
      apartments?.length > 0 && Math.max(...apartments?.map(item => item.area));

    return (
      <BaseSection>
        <div className="info">
          <ul className="info__i">
            {min && max && <li>{t('residences.area')}</li>}
            {priceMin && <li>{t('residences.price')}</li>}
            {deadline && <li>{t('residences.deadline')}</li>}
            {hasBillOfSale && <li>{t('residences.billOfSale')}</li>}
          </ul>
          <ul className="info__i info__i--right">
            {min && max && (
              <li>{t('residences.from_to_area', { from: min, to: max })}</li>
            )}
            {priceMin && (
              <li>{t('residences.priceMin', { priceMin, currency })}</li>
            )}

            {deadline && <li>{deadline}</li>}
            {hasBillOfSale && <li>{t('residences.hasBillOfSale')}</li>}
          </ul>
        </div>
      </BaseSection>
    );
  }
);

InfoSection.displayName = `InfoSection`;

InfoSection.propTypes = {
  priceMin: PropTypes.number,
  priceMax: PropTypes.number,
  currency: PropTypes.string,
  hasBillOfSale: PropTypes.bool,
  deadline: PropTypes.string,
  apartments: PropTypes.array
};

export default InfoSection;
